import { HeaderNavigationItem } from '@/components/Header/navigation';
import PopoverMenuButton from '@/components/PopoverMenuButton';
import { PopoverGroup } from '@headlessui/react';
import { Link } from 'react-router-dom';

interface DesktopNavigationProps {
  navigation: HeaderNavigationItem[];
}

const DesktopNavigation = ({ navigation }: DesktopNavigationProps) => {
  return (
    <PopoverGroup
      className={`${navigation.length > 3 ? 'lg:gap-x-4' : 'lg:gap-x-8'} hidden lg:flex`}
    >
      {navigation.map((item) =>
        item.items ? (
          <PopoverMenuButton key={item.name} item={item} items={item.items} />
        ) : item.href ? (
          <Link
            to={item.href}
            key={item.name}
            className="text-sm font-semibold leading-6 text-gray-900 rounded-md hover:bg-gray-100 transition duration-300 ease-in-out px-3 py-1.5"
          >
            {item.name}
          </Link>
        ) : (
          <span key={item.name}>{item.name}</span>
        ),
      )}
    </PopoverGroup>
  );
};

export default DesktopNavigation;
